import React from 'react';
import { Box, Typography } from '@mui/material';
import { elliottTokens as t } from './tokens';
import ElliottFace from '../../../../../components/ElliottFace';

// Avatar column width = avatar (36) + gap (14) = 50px. Controls that need to
// align under Elliott's text (pills, inputs) indent by this much.
export const AVATAR_GUTTER = 50;

// Elliott's living, smiling face — shared across every Elliott surface.
export const ElliottAvatar: React.FC<{ size?: number }> = ({ size = 36 }) => (
  <ElliottFace size={size} glow />
);

// Shared body-copy style for Elliott messages, so all thread text renders identically.
// (Rendered via MUI Typography to avoid the app's global `p { font-size … !important }` rules.)
export const messageBodySx = {
  color: t.textPrimary,
  fontSize: `${t.bodySize}px`,
  lineHeight: `${t.bodyLineHeight}px`,
  fontWeight: 400,
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word'
} as const;

type ElliottMessageProps = {
  children: React.ReactNode;
};

const ElliottMessage: React.FC<ElliottMessageProps> = ({ children }) => (
  <Box sx={{ display: 'flex', gap: '14px', alignItems: 'flex-start', width: '100%' }}>
    <ElliottAvatar />
    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '6px', pt: '6px' }}>
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: 700,
          letterSpacing: '1.6px',
          lineHeight: 'normal',
          backgroundImage: t.brandyTextGradient,
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          color: 'transparent'
        }}
      >
        ELLIOTT
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', '& strong': { fontWeight: 700 } }}>
        {children}
      </Box>
    </Box>
  </Box>
);

export default ElliottMessage;
